import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Mainpage from "./components/Mainpage";
import Services from "./components/Services";
import SingleProject from "./components/SingleProject";
import Works from "./components/Works";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from './components/About';
import Jobs from './components/Jobs';

class App extends Component {

  componentDidMount(){
    AOS.init();
  }

  render() {
    return (
      <Router className="App">
        <div>
          <Navbar/>
          <Switch>
            <Route exact path="/" component={Mainpage} />
            <Route exact path="/services" component={Services} />
            <Route exact path="/work" component={Works} />
            <Route exact path="/about" component={About} />
            <Route exact path="/jobs" component={Jobs} />
            <Route exact path="/projectInfo/:id" component={SingleProject} />
          </Switch>
          <Footer/>
        </div>
      </Router>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js